import { SupportDrawer } from 'shared/common/Header/components/SupportModal/Mobile'
import { Icon } from 'shared/iconpack'

import { Button } from 'shared/ui/button'

import { useDisclosure } from 'shared/hooks/useDisclosure'

import { globalStyles } from 'shared/config/styles/globalStyles'

import styles from './Support.module.scss'

interface SupportProps {
  label: string
  className?: string
}

export function Support({ label }: SupportProps) {
  const { isOpen, onClose, onOpen } = useDisclosure()

  return (
    <>
      <Button
        fullWidth
        onClick={onOpen}
        variant="additional"
        className={styles.item}
      >
        <span>{label}</span>
        <Icon
          name="chevronRight"
          size={16}
          color={globalStyles['--icon-secondary']}
        />
      </Button>
      <SupportDrawer isOpen={isOpen} onClose={onClose} />
    </>
  )
}
